import { lazy } from "react";

export const _404 = lazy(() => import("@/components/common/_404"));
export const Dashboard= lazy(() =>
  import(/* webpackChunkName: "Login" */ "../modules/dashboard/pages")
);

export const Users = lazy(() =>
  import(/* webpackChunkName: "Home" */ "../modules/users/pages/index")
);

export const Login = lazy(() =>
  import(/* webpackChunkName: "Login" */ "../modules/authentication/pages")
);

export const Subscription = lazy(() =>
  import(
    /* webpackChunkName: "Subscription" */ "../modules/subscription/pages/index"
  )
);
export const Memoirs = lazy(() =>
  import(
    /* webpackChunkName: "Memoirs" */ "../modules/memoirs/pages/index"
  )
);

export const Biographies = lazy(() =>
  import(
    /* webpackChunkName: "Biographies" */ "../modules/biographies/pages/index"
  )
);